import { useTourGate } from "../../contexts/TourGateContext";
import TourTooltip from "./TourTooltip";

// Identity has to stay stable across renders or Joyride remounts the tooltip,
// so the gate is read here rather than closed over where the tour is configured
const GatedTourTooltip = (props) => {
   const gate = useTourGate();

   return (
      <TourTooltip
         {...props}
         isBlocked={Boolean(gate?.isBlocked)}
         blockedHint={gate?.hint}
         onSkipStop={gate?.skipStop}
      />
   );
};

export default GatedTourTooltip;
